import { GoogleAdsRequestTypeGq } from '../../../graphql/projects/models/GoogleAdsRequestTypeGq';

export const KeywordSearchLimits: Record<GoogleAdsRequestTypeGq, number> = {
  [GoogleAdsRequestTypeGq.LONG_TAIL]: 100,
  [GoogleAdsRequestTypeGq.URL]: 100,
  [GoogleAdsRequestTypeGq.RELATED]: 100,
  [GoogleAdsRequestTypeGq.SITE]: 1,
  [GoogleAdsRequestTypeGq.EXACT]: 20000,

  // Irrelevant
  [GoogleAdsRequestTypeGq.CATEGORY]: 0,
  [GoogleAdsRequestTypeGq.COPY]: 0,
  [GoogleAdsRequestTypeGq.LEGACY]: 0,
};

export const KeywordSearchWarningLimits: Record<GoogleAdsRequestTypeGq, number> = {
  [GoogleAdsRequestTypeGq.LONG_TAIL]: 10,
  [GoogleAdsRequestTypeGq.URL]: 10,
  [GoogleAdsRequestTypeGq.RELATED]: 10,
  [GoogleAdsRequestTypeGq.SITE]: 1,
  [GoogleAdsRequestTypeGq.EXACT]: 5000,

  // Irrelevant
  [GoogleAdsRequestTypeGq.CATEGORY]: 0,
  [GoogleAdsRequestTypeGq.COPY]: 0,
  [GoogleAdsRequestTypeGq.LEGACY]: 0,
};

// For error messages and basis for the above limits
export const KeywordSearchSeedMultipliers: Record<GoogleAdsRequestTypeGq, number> = {
  [GoogleAdsRequestTypeGq.LONG_TAIL]: 1000,
  [GoogleAdsRequestTypeGq.URL]: 1000,
  [GoogleAdsRequestTypeGq.RELATED]: 1000,
  [GoogleAdsRequestTypeGq.SITE]: 25000,
  [GoogleAdsRequestTypeGq.EXACT]: 1,

  // Irrelevant
  [GoogleAdsRequestTypeGq.CATEGORY]: 0,
  [GoogleAdsRequestTypeGq.COPY]: 0,
  [GoogleAdsRequestTypeGq.LEGACY]: 0,
};

// Generate keyword ideas
// https://developers.google.com/google-ads/api/docs/keyword-planning/generate-keyword-ideas
// KeywordSeed:
// UrlSeed:
// KeywordAndUrlSeed:
// SiteSeed: top-level domain name www.example.com - > max 250 000 keywords
